
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34009',
  depVersions: {
  "documents-public-ui": "static-1.34009",
  "client-types": "static-1.446",
  "documents-lib": "static-1.34014",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1943",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5409",
  "hs-test-utils": "static-1.7821",
  "hub-http": "static-1.6036",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11248",
  "I18n": "static-7.1574",
  "jasmine-immutable": "static-1.2834",
  "jasmine-runner": "static-1.6288",
  "lodash": "static-1.3",
  "quartz": "static-1.6755",
  "react": "static-7.180",
  "react-dlb": "static-1.73",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16466",
  "reporting-data": "static-1.66589",
  "reporting-testing-lib": "static-1.8522",
  "reporting-visualizations": "static-1.58665",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4581",
  "webpack-env": "static-1.54",
  "atom": "static-1.4885",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2303",
  "classnames": "static-2.10",
  "cssUtils": "static-1.736",
  "customer-data-filters-ui": "static-1.38956",
  "customer-data-objects": "static-1.7465",
  "customer-data-property-utils": "static-1.7894",
  "data-fetching-client": "static-1.9493",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4345",
  "flux-actions": "static-1.310",
  "FormsCommonComponents": "static-1.85322",
  "FormUrlGenerator": "static-2.4544",
  "foundations-components": "static-1.7554",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11556",
  "icons": "static-2.623",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6976",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3674",
  "property-translator": "static-1.5228",
  "quartz-config": "static-1.533",
  "quartz-core": "static-1.5974",
  "quick-fetch": "static-1.3750",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5188",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7976",
  "reference-resolvers-lite": "static-1.7910",
  "report-customization-components": "static-1.12546",
  "reporting-enablement": "static-1.22119",
  "reporting-reports": "static-1.66267",
  "reporting-snowflake": "static-1.55207",
  "reporting-ui-components": "static-2.63860",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4450",
  "sales-content-partitioning": "static-1.8751",
  "SalesContentIndexUI": "static-3.8926",
  "sanitize": "static-1.4290",
  "sanitize-text": "static-1.7958",
  "self-service-api": "static-1.10052",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1568",
  "signup-constants": "static-1.18440",
  "signup-ui-lego-core": "static-1.20450",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4586",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10810",
  "ui-addon-i18n": "static-1.10957",
  "ui-addon-react-router-dom": "static-1.9362",
  "ui-addon-upgrades": "static-9.17681",
  "ui-asset-management-lib": "static-1.10730",
  "ui-images": "static-2.1096",
  "UIComponents": "static-3.8195",
  "usage-tracker": "static-1.7150",
  "usage-tracker-container": "static-1.7140",
  "usage-tracker-core": "static-1.7000",
  "usage-tracker-public": "static-1.6961",
  "viral-links-lib": "static-1.6851",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3244",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3032",
  "quartz-webpack": "static-1.2979",
  "ai-components-ui-library": "static-1.8385",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4652",
  "foundations-theming": "static-1.4227",
  "quartz-auth": "static-1.430",
  "ui-business-units-lib": "static-1.8845",
  "usage-tracker-session-replay": "static-1.4836",
  "foundations-theming-base": "static-1.3212",
  "HeadJS": "static-2.713",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2932",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4142",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7740",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3433",
  "persist-promise": "static-1.3524",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.579",
  "hs-story-utils": "static-1.9243",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9509",
  "hubspotter-http": "static-1.4493",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7063",
  "crm-message-bus": "static-1.42405",
  "customer-data-filters-ui-msw-helpers": "static-1.21391",
  "customer-data-objects-ui-components": "static-1.12825",
  "customer-data-reference-ui-components": "static-1.12962",
  "customer-data-ui-utilities": "static-1.9639",
  "framework-builder-read-service-client": "static-1.3848",
  "framework-data-schema-quick-fetch": "static-1.6594",
  "framework-data-schema-resolvers": "static-1.6689",
  "inbound-db-properties-service-client": "static-1.3690",
  "multi-account-reference-resolvers": "static-1.789",
  "onboarding-tours": "static-1.16283",
  "reporting-datasets-permissions-lib": "static-1.13093",
  "ui-addon-teams": "static-1.21263",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67663",
  "customer-data-properties": "static-1.50839",
  "forms-ai-lib": "static-1.4030",
  "forms-utils-lib": "static-1.12195",
  "foundations-components-test-utils": "static-1.5037",
  "react-dnd-compat": "static-1.4436",
  "react-tinymce": "static-1.54659",
  "tinymce-config": "static-2.53785",
  "ui-gdpr-components": "static-1.10163",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3823",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1254",
  "ui-fonts": "static-1.510",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.798",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.420",
  "quartz-i18n": "static-1.430",
  "quartz-routing": "static-1.185",
  "quartz-test": "static-1.430",
  "quartz-tracking": "static-1.134",
  "batch-promise": "static-1.1367",
  "external-options-client-types": "static-1.3999",
  "react-colorpicker": "static-2.10025",
  "copilot-toolkit": "static-1.10571",
  "data-quality-ui-library": "static-1.12354",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40693",
  "reporting-insights-lib": "static-1.1204",
  "reporting-plugins": "static-1.10004",
  "ui-addon-draggable-compat": "static-2.4069",
  "ui-addon-opt": "static-4.8200",
  "ui-shepherd-react": "static-3.9963",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24768",
  "hubspot-apollo-client": "static-1.4697",
  "sales-templates-service-types-lib": "static-1.4006",
  "merchandise-lib": "static-1.259",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5502",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3919",
  "timezone-utils": "static-2.5060",
  "bender-build-tools": "static-1.2956",
  "chatspot-core": "static-1.20387",
  "chirp-fetch": "static-1.1698",
  "bend-plugin-foundations-theming": "static-1.2710",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9507",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3638",
  "crm-pipelines-api-client-types": "static-1.3979",
  "multi-currency-client-types": "static-1.3532",
  "getting-started-shared-tasks": "static-1.17925",
  "growth-data-modal": "static-1.5175",
  "growth-onboarding-confetti": "static-1.2888",
  "growth-onboarding-next-action-utils": "static-1.1327",
  "navigation-components": "static-1.17312",
  "onboarding-tours-client": "static-1.4497",
  "onboarding-tours-utils": "static-1.349",
  "ui-shepherd-tracker": "static-1.7344",
  "ui-universal-auth": "static-1.8720",
  "user-context": "static-1.4915",
  "cms-field-types": "static-1.4622",
  "content-icons-ui": "static-1.2158",
  "integrations-lib": "static-1.15460",
  "calling-global-api": "static-1.63724",
  "calling-internal-common": "static-1.31110",
  "calling-lifecycle-internal": "static-1.65106",
  "calling-lifecycle-messages": "static-1.57400",
  "commerce-products-lib": "static-1.8902",
  "crm-links": "static-1.6083",
  "file-manager-components": "static-1.22936",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.494",
  "inbounddb-objects-service-types": "static-1.4063",
  "meetings-icalendar-utils-lib": "static-1.449",
  "object-builder-ui-client": "static-1.48029",
  "pipeline-validation-client-types": "static-1.3802",
  "property-value-citations": "static-1.1453",
  "pulse": "static-1.330",
  "smart-property-lib": "static-1.5968",
  "tiered-pricing": "static-1.851",
  "ui-addon-iframeable": "static-1.8861",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19495",
  "tinymce-themes": "static-1.55755",
  "data-token-picker": "static-1.16066",
  "hub-http-contrib": "static-1.2859",
  "interframe": "static-3.4605",
  "tinymce-data": "static-1.39870",
  "tinymce-plugins": "static-1.56899",
  "ui-addon-sales-email": "static-1.5029",
  "magpie-lib": "static-1.5410",
  "magpie-types": "static-1.4870",
  "simple-logging-lib": "static-1.2866",
  "content-assistance-lib": "static-1.7471",
  "dashboard-lib": "static-1.80688",
  "ExportDialog": "static-6.10203",
  "hubspot-prosemirror": "static-1.17643",
  "hubspot-prosemirror-plugins": "static-1.17635",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8508",
  "campaign-roi-lib": "static-1.8319",
  "feedback-loader": "static-1.28883",
  "onboarding-scopes": "static-1.6279",
  "apollo-link-hub-http": "static-2.4466",
  "hubspot-apollo-cache": "static-1.156",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2173",
  "purchase-motions-api": "static-1.5505",
  "trials-service-types": "static-1.3730",
  "growth-onboarding-next-action-components": "static-1.1355",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.541",
  "unified-auth-core-lib": "static-1.515",
  "getting-started-shared-tasks-store": "static-1.17043",
  "integrations-error-boundary-lib": "static-1.12875",
  "integrations-tracking-lib": "static-1.5405",
  "native-integrations-shared-strings": "static-1.7604",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10187",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31116",
  "shared-worker-versioning": "static-1.10854",
  "calling-usage-tracker": "static-1.6356",
  "voice-sms-access-library": "static-1.288",
  "customer-data-tracking": "static-1.6698",
  "commerce-permissions": "static-1.575",
  "products-iframe-lib": "static-1.7356",
  "products-ui-components-shared-msw-handlers": "static-1.9891",
  "location-customization-utils-lib": "static-1.8608",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3971",
  "video-components-external": "static-1.10610",
  "video-data-lib": "static-1.34268",
  "directed-graph": "static-1.753",
  "event-emitter": "static-1.763",
  "breeze-intelligence-kit": "static-1.5342",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9592",
  "fsm": "static-1.3548",
  "policy-lib": "static-1.6603",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9655",
  "navigation-messaging": "static-1.6639",
  "FileManagerLib": "static-1.38576",
  "NamespacedHubStyle": "static-2.8911",
  "FileManagerCore": "static-1.38435",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12062",
  "layout-dnd-utils": "static-1.11037",
  "react-codemirror": "static-1.10443",
  "ui-addon-emoji-picker": "static-1.9704",
  "ui-brand-identity-lib": "static-1.13957",
  "ui-addon-video-player": "static-1.8512",
  "ui-coaching-tips": "static-1.27981",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8384",
  "payment-link-components": "static-1.22977",
  "EmailSignatureEditor": "static-1.23940",
  "eligibility-engine-service-types": "static-1.3011",
  "universal-page-editor-lib": "static-1.2816",
  "calling-orchestration-schema": "static-1.35065",
  "sales-views-client-types": "static-1.4103",
  "crm-record-cards-service-types": "static-1.3460",
  "content-media-composition-data-lib": "static-1.11510",
  "content-media-compositions": "static-2.15517",
  "media-bridge-lib": "static-1.18589",
  "trellis-story-utils": "static-1.4337",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5634",
  "FileManagerImages": "static-1.36087",
  "video-components": "static-1.12613",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4348",
  "video-embed": "static-1.35102",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67738",
  "layout-data-lib": "static-1.9362",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6399",
  "commerce-tours-lib": "static-1.5741",
  "growth-onboarding-reliability": "static-1.4902",
  "sales-checkout-service-client": "static-1.3484",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21331",
  "sales-email-signature-service-client": "static-1.3660",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21396",
  "outpost": "static-1.4020",
  "advanced-menus-core": "static-1.14836",
  "advanced-menus-lib": "static-1.11809",
  "ui-memberships-settings-lib": "static-1.33466",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14835",
  "simple-menus-lib": "static-1.16352"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34009",
  "client-types": "/client-types/static-1.446",
  "documents-lib": "/documents-lib/static-1.34014",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1943",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5409",
  "hs-test-utils": "/hs-test-utils/static-1.7821",
  "hub-http": "/hub-http/static-1.6036",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11248",
  "I18n": "/I18n/static-7.1574",
  "jasmine-immutable": "/jasmine-immutable/static-1.2834",
  "jasmine-runner": "/jasmine-runner/static-1.6288",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6755",
  "react": "/react/static-7.180",
  "react-dlb": "/react-dlb/static-1.73",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16466",
  "reporting-data": "/reporting-data/static-1.66589",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8522",
  "reporting-visualizations": "/reporting-visualizations/static-1.58665",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4581",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4885",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2303",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.736",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38956",
  "customer-data-objects": "/customer-data-objects/static-1.7465",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7894",
  "data-fetching-client": "/data-fetching-client/static-1.9493",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4345",
  "flux-actions": "/flux-actions/static-1.310",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85322",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4544",
  "foundations-components": "/foundations-components/static-1.7554",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11556",
  "icons": "/icons/static-2.623",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6976",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3674",
  "property-translator": "/property-translator/static-1.5228",
  "quartz-config": "/quartz-config/static-1.533",
  "quartz-core": "/quartz-core/static-1.5974",
  "quick-fetch": "/quick-fetch/static-1.3750",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5188",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7976",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7910",
  "report-customization-components": "/report-customization-components/static-1.12546",
  "reporting-enablement": "/reporting-enablement/static-1.22119",
  "reporting-reports": "/reporting-reports/static-1.66267",
  "reporting-snowflake": "/reporting-snowflake/static-1.55207",
  "reporting-ui-components": "/reporting-ui-components/static-2.63860",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4450",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8751",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8926",
  "sanitize": "/sanitize/static-1.4290",
  "sanitize-text": "/sanitize-text/static-1.7958",
  "self-service-api": "/self-service-api/static-1.10052",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1568",
  "signup-constants": "/signup-constants/static-1.18440",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20450",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4586",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10810",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10957",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9362",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17681",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10730",
  "ui-images": "/ui-images/static-2.1096",
  "UIComponents": "/UIComponents/static-3.8195",
  "usage-tracker": "/usage-tracker/static-1.7150",
  "usage-tracker-container": "/usage-tracker-container/static-1.7140",
  "usage-tracker-core": "/usage-tracker-core/static-1.7000",
  "usage-tracker-public": "/usage-tracker-public/static-1.6961",
  "viral-links-lib": "/viral-links-lib/static-1.6851",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3244",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3032",
  "quartz-webpack": "/quartz-webpack/static-1.2979",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8385",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4652",
  "foundations-theming": "/foundations-theming/static-1.4227",
  "quartz-auth": "/quartz-auth/static-1.430",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8845",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4836",
  "foundations-theming-base": "/foundations-theming-base/static-1.3212",
  "HeadJS": "/HeadJS/static-2.713",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2932",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4142",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7740",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3433",
  "persist-promise": "/persist-promise/static-1.3524",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.579",
  "hs-story-utils": "/hs-story-utils/static-1.9243",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9509",
  "hubspotter-http": "/hubspotter-http/static-1.4493",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7063",
  "crm-message-bus": "/crm-message-bus/static-1.42405",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21391",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12825",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12962",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9639",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3848",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6594",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6689",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3690",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.789",
  "onboarding-tours": "/onboarding-tours/static-1.16283",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13093",
  "ui-addon-teams": "/ui-addon-teams/static-1.21263",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67663",
  "customer-data-properties": "/customer-data-properties/static-1.50839",
  "forms-ai-lib": "/forms-ai-lib/static-1.4030",
  "forms-utils-lib": "/forms-utils-lib/static-1.12195",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5037",
  "react-dnd-compat": "/react-dnd-compat/static-1.4436",
  "react-tinymce": "/react-tinymce/static-1.54659",
  "tinymce-config": "/tinymce-config/static-2.53785",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10163",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3823",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1254",
  "ui-fonts": "/ui-fonts/static-1.510",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.420",
  "quartz-i18n": "/quartz-i18n/static-1.430",
  "quartz-routing": "/quartz-routing/static-1.185",
  "quartz-test": "/quartz-test/static-1.430",
  "quartz-tracking": "/quartz-tracking/static-1.134",
  "batch-promise": "/batch-promise/static-1.1367",
  "external-options-client-types": "/external-options-client-types/static-1.3999",
  "react-colorpicker": "/react-colorpicker/static-2.10025",
  "copilot-toolkit": "/copilot-toolkit/static-1.10571",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12354",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40693",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1204",
  "reporting-plugins": "/reporting-plugins/static-1.10004",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4069",
  "ui-addon-opt": "/ui-addon-opt/static-4.8200",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9963",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24768",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4697",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4006",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5502",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3919",
  "timezone-utils": "/timezone-utils/static-2.5060",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "chatspot-core": "/chatspot-core/static-1.20387",
  "chirp-fetch": "/chirp-fetch/static-1.1698",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2710",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9507",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3638",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3979",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3532",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17925",
  "growth-data-modal": "/growth-data-modal/static-1.5175",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2888",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1327",
  "navigation-components": "/navigation-components/static-1.17312",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4497",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.349",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7344",
  "ui-universal-auth": "/ui-universal-auth/static-1.8720",
  "user-context": "/user-context/static-1.4915",
  "cms-field-types": "/cms-field-types/static-1.4622",
  "content-icons-ui": "/content-icons-ui/static-1.2158",
  "integrations-lib": "/integrations-lib/static-1.15460",
  "calling-global-api": "/calling-global-api/static-1.63724",
  "calling-internal-common": "/calling-internal-common/static-1.31110",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65106",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57400",
  "commerce-products-lib": "/commerce-products-lib/static-1.8902",
  "crm-links": "/crm-links/static-1.6083",
  "file-manager-components": "/file-manager-components/static-1.22936",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.494",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4063",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.449",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48029",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3802",
  "property-value-citations": "/property-value-citations/static-1.1453",
  "pulse": "/pulse/static-1.330",
  "smart-property-lib": "/smart-property-lib/static-1.5968",
  "tiered-pricing": "/tiered-pricing/static-1.851",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8861",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19495",
  "tinymce-themes": "/tinymce-themes/static-1.55755",
  "data-token-picker": "/data-token-picker/static-1.16066",
  "hub-http-contrib": "/hub-http-contrib/static-1.2859",
  "interframe": "/interframe/static-3.4605",
  "tinymce-data": "/tinymce-data/static-1.39870",
  "tinymce-plugins": "/tinymce-plugins/static-1.56899",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5029",
  "magpie-lib": "/magpie-lib/static-1.5410",
  "magpie-types": "/magpie-types/static-1.4870",
  "simple-logging-lib": "/simple-logging-lib/static-1.2866",
  "content-assistance-lib": "/content-assistance-lib/static-1.7471",
  "dashboard-lib": "/dashboard-lib/static-1.80688",
  "ExportDialog": "/ExportDialog/static-6.10203",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17643",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17635",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8508",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8319",
  "feedback-loader": "/feedback-loader/static-1.28883",
  "onboarding-scopes": "/onboarding-scopes/static-1.6279",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4466",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.156",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2173",
  "purchase-motions-api": "/purchase-motions-api/static-1.5505",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1355",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.541",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.515",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17043",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12875",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5405",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7604",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10187",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31116",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10854",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6356",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.288",
  "customer-data-tracking": "/customer-data-tracking/static-1.6698",
  "commerce-permissions": "/commerce-permissions/static-1.575",
  "products-iframe-lib": "/products-iframe-lib/static-1.7356",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9891",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8608",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3971",
  "video-components-external": "/video-components-external/static-1.10610",
  "video-data-lib": "/video-data-lib/static-1.34268",
  "directed-graph": "/directed-graph/static-1.753",
  "event-emitter": "/event-emitter/static-1.763",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5342",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9592",
  "fsm": "/fsm/static-1.3548",
  "policy-lib": "/policy-lib/static-1.6603",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9655",
  "navigation-messaging": "/navigation-messaging/static-1.6639",
  "FileManagerLib": "/FileManagerLib/static-1.38576",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8911",
  "FileManagerCore": "/FileManagerCore/static-1.38435",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12062",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11037",
  "react-codemirror": "/react-codemirror/static-1.10443",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9704",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13957",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8512",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27981",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8384",
  "payment-link-components": "/payment-link-components/static-1.22977",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23940",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2816",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35065",
  "sales-views-client-types": "/sales-views-client-types/static-1.4103",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11510",
  "content-media-compositions": "/content-media-compositions/static-2.15517",
  "media-bridge-lib": "/media-bridge-lib/static-1.18589",
  "trellis-story-utils": "/trellis-story-utils/static-1.4337",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5634",
  "FileManagerImages": "/FileManagerImages/static-1.36087",
  "video-components": "/video-components/static-1.12613",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4348",
  "video-embed": "/video-embed/static-1.35102",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67738",
  "layout-data-lib": "/layout-data-lib/static-1.9362",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6399",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5741",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4902",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3484",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21331",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3660",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21396",
  "outpost": "/outpost/static-1.4020",
  "advanced-menus-core": "/advanced-menus-core/static-1.14836",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11809",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33466",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14835",
  "simple-menus-lib": "/simple-menus-lib/static-1.16352"
}
};
